import { Slot } from "@radix-ui/react-slot";

import { cn } from "@/lib/utils";

export function Page({
  children,
  className,
  asChild = false,
}: {
  children: React.ReactNode;
  className?: string;
  asChild?: boolean;
}) {
  const Comp = asChild ? Slot : "div";
  return (
    <Comp
      className={cn(
        "text-slate-normal",
        "w-screen md:w-auto md:max-w-304 min-h-screen mx-auto px-4 md:px-10 xl:px-16 pt-14 md:pt-14 pb-20 flex flex-col gap-6 md:gap-8",
        className,
      )}
    >
      {children}
    </Comp>
  );
}
